// @ts-nocheck
function initSwipers() {
  if (typeof Swiper === 'undefined') {
    return;
  }

  const highlightElement = document.querySelector('.featured-products__highlight');
  const overviewElement = document.querySelector('.featured-products__overview');

  if (!highlightElement || !overviewElement) {
    return;
  }

  if (highlightElement.swiper) {
    highlightElement.swiper.destroy(true, true);
  }
  if (overviewElement.swiper) {
    overviewElement.swiper.destroy(true, true);
  }

  const highlightSlider = new Swiper('.featured-products__highlight', {
    speed: 500,
    slidesPerView: 1,
    loop: true,
    effect: 'fade',
    simulateTouch: false,
    shortSwipes: false,
    longSwipes: false,
  });

  const overviewSlideCount = document.querySelectorAll(
    '.featured-products__overview .swiper-slide',
  ).length;

  const overviewSlider = new Swiper('.featured-products__overview', {
    speed: 500,
    slidesPerView: 'auto',
    loopedSlides: overviewSlideCount,
    navigation: {
      nextEl: '.featured-products__nav .swiper-button-next',
      prevEl: '.featured-products__nav .swiper-button-prev',
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    loop: true,
    on: {
      slideNextTransitionStart: () => {
        highlightSlider.slideNext();
      },
      slidePrevTransitionStart: () => {
        highlightSlider.slidePrev();
      },
    },
  });

  overviewSlider.slideNext(0, false);
  overviewSlider.autoplay.start();
}

(function waitForSwiper() {
  let attempts = 0;
  const maxAttempts = 50;

  function checkAndInit() {
    if (typeof Swiper !== 'undefined') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSwipers, { once: true });
      } else {
        initSwipers();
      }
    } else {
      attempts++;
      if (attempts < maxAttempts) {
        setTimeout(checkAndInit, 50);
      }
    }
  }

  checkAndInit();
})();

document.addEventListener('shopify:section:load', event => {
  const container = document.getElementById(`shopify-section-${event.detail.sectionId}`);
  if (container && container.classList.contains('shopify-section--featured-products')) {
    setTimeout(() => {
      if (typeof Swiper !== 'undefined') {
        initSwipers();
      }
    }, 100);
  }
});
